import { createRootRoute, createRoute, redirect, Outlet } from '@tanstack/react-router';
import { portalRouteTree } from '@/features/client-portal/routes/portalRoutes';

// Standalone root route for the portal app
export const rootRoute = createRootRoute({
  component: Outlet,
});

/**
 * Invite landing route. The backend sends portal invitation emails with
 * links shaped like `https://portal.fedix.com.au/accept-invite?token=…`.
 * Without this alias, those links 404'd because the SPA had no
 * `/accept-invite` route, leaving invitees stranded. Forwarding the
 * query string verbatim hands the signed JWT to `PortalRegisterPage`,
 * which decodes the email, pins it to the form, and includes the token
 * when calling `POST /auth/self-register`.
 */
const acceptInviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accept-invite',
  beforeLoad: ({ location }) => {
    throw redirect({
      to: '/portal/register',
      // `search` is forwarded verbatim so `?token=…` (or `?invite=…`)
      // reaches the register page intact.
      search: location.search as Record<string, unknown>,
    });
  },
});

// Catch-all redirect to /portal/login for unknown paths
const catchAllRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    window.location.href = '/portal/dashboard';
  },
});

// Build the full route tree
export const routeTree = rootRoute.addChildren([
  acceptInviteRoute,
  portalRouteTree,
  catchAllRoute,
]);
